import { render, staticRenderFns } from "./distribution-chart-inspection.vue?vue&type=template&id=1affd50e&scoped=true"
import script from "./distribution-chart-inspection.vue?vue&type=script&lang=js"
export * from "./distribution-chart-inspection.vue?vue&type=script&lang=js"
import style0 from "./distribution-chart-inspection.vue?vue&type=style&index=0&id=1affd50e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1affd50e",
  null
  
)

export default component.exports